'use client';

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  tracesSampleRate: 0,
  environment: process.env.NEXT_PUBLIC_LOGGER_ENV,
  ignoreErrors: [/AbortError/, /^Dropped events\s*\[/],
  integrations: integrations =>
    integrations.filter(
      integration => !['Http', 'Console'].includes(integration.name),
    ),
});
